import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.isLoggedIn();

  if (!authService.userIsAdmin()) {
    await router.navigate(['/']);
    return false;
  }
  return true;
};
